
import { MapLocation } from '@/types/location';

export const buildingMountedScreens: MapLocation[] = [
  {
    id: 10001,
    name: "2 - Building-Mounted Screens – Medina",
    type: "Building Screens",
    devices: 1,
    coordinates: [24.496556, 39.635611], // Lat, Lng format for Leaflet
    region: "Medina",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Location: Mutlaq Bin Abdul'Aali Al-Murqi Al-Otaibi Building\nPrice: 6,071.43 SAR per screen per day",
      screenDimensions: "10m x 16m",
      referenceImage: "/images/3fbfec4c-21ed-4fac-936a-c008f9ed1520.png"
    }
  },
  {
    id: 10002,
    name: "1 - Building-Mounted Screens – Medina",
    type: "Building Screens",
    devices: 1,
    coordinates: [24.471889, 39.658944], // Converted from 24°28'18.8"N 39°39'22.6"E
    region: "Medina",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Location: Downward King Abdulaziz Road\nPrice: 8,929 SAR per screen per day",
      screenDimensions: "25m x 17m",
      referenceImage: "/images/5414c52c-da41-47b4-884b-ec136fad10df.png"
    }
  },
  {
    id: 10029,
    name: "Building-Mounted Screen – Eastern Province",
    type: "Building Screens",
    devices: 1,
    coordinates: [26.308766667, 50.212861111], // Converted from 26°18'35.54"N 50°12'44.30"E
    region: "Eastern",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Building-Mounted Screen in Eastern Province\nPrice: 5,000 SAR per screen per day",
      screenDimensions: "7m x 31m",
      referenceImage: "/images/61d2cdff-2606-4f4a-9cbd-0f11cc4e3f96.png"
    }
  }
];
